// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, verifyPhoneLoginClient } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitVerifyPhoneLoginClientApi = createAsyncThunk(
  "hitVerifyPhoneLoginClientApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      };
      const url = ApiBaseUrl + verifyPhoneLoginClient;
      const response = await axios.put(url, payload, config);
      //console.log("response from verify phone login client api", response);
      return response.data;
    } catch (error) {
      showToast(error.response.data.message, "error");
      throw error.response.data;
    }
  }
);

const VerifyLoginPhoneClientSlice = createSlice({
  name: "verifyLoginPhoneClientReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitVerifyPhoneClientData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitVerifyPhoneLoginClientApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitVerifyPhoneLoginClientApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        //console.log("action.payload11111111111111", action.payload);
        if (
          action.payload?.status == true &&
          action.payload?.data?.accessToken
        ) {
          localStorage.setItem("clientToken", action.payload.data.accessToken);
          localStorage.setItem("clientId", action.payload.data._id);
          localStorage.setItem("clientData", JSON.stringify(action.payload.data));
        }
      })
      .addCase(hitVerifyPhoneLoginClientApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitVerifyPhoneClientData } = VerifyLoginPhoneClientSlice.actions;
export default VerifyLoginPhoneClientSlice.reducer;
